// extracted by mini-css-extract-plugin
module.exports = {"test":"css_test__bwD4u","moveitback":"css_moveitback__XcpbR","moveit":"css_moveit__h5DFY","testBack":"css_testBack__PXhad","text":"css_text__y5eJ_","textTwo":"css_textTwo__0E55V"};